import {
  IconListDefault,
  IconPlayDefault,
  IconUserSingleDefault,
} from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import Link from 'components/Link'
import Sticky from 'components/Sticky'
import { allAccessPassPath, articlesPath, homePath } from 'libs/paths'

const StickyFooter = () => {
  const { t } = useTranslation('@mc/next')

  return (
    <Sticky>
      <nav
        data-testid='sticky-footer'
        className='row no-gutters mc-text-small mc-text--center mc-background--color-dark justify-content-center mc-py-2'
      >
        <ul className='row no-gutters align-items-center justify-content-around col-12 col-lg-8'>
          <li className='col-4 list-unstyled'>
            <Link href={articlesPath()}>
              <IconListDefault size='md' />
              <p className='mc-mt-1'>{t('article.stickyFooter.articles')}</p>
            </Link>
          </li>
          <li className='col-4 list-unstyled'>
            <Link href={allAccessPassPath()} passHref>
              <IconPlayDefault size='md' />
              <p className='mc-mt-1'>{t('article.stickyFooter.videos')}</p>
            </Link>
          </li>
          <li className='col-4 list-unstyled'>
            <Link href={homePath()} passHref>
              <IconUserSingleDefault size='md' />
              <p className='mc-mt-1'>{t('article.stickyFooter.instructors')}</p>
            </Link>
          </li>
        </ul>
      </nav>
    </Sticky>
  )
}

export default StickyFooter
